import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

//import axios from 'axios';
import axios_api from "../Api";

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';

import { TicketUpdateForm } from './common/TicketForms';


function ChatMessage({followUp}){

  //console.log(followUp);

  let attachment = false;
  if (followUp.attachments.length > 0){
    attachment = followUp.attachments[0]
  }

  return (
    <>
      {followUp.user.userprofile.usertype === 'LAB' &&
        <div className="alert alert-primary" role="alert">
          <p>{followUp.comment}</p>
          {attachment ? <a href={attachment.file} class="alert-link">приложенный файл</a> : <></> }
        </div>
      }
      {followUp.user.userprofile.usertype === 'LAWYER' &&
        <div className="alert alert-info" role="alert">
          <p>{followUp.comment}</p>
          {attachment ? <a href={attachment.file} class="alert-link">приложенный файл</a> : <></> }
        </div>
      }     
      <div className="d-grid d-md-flex justify-content-between">
        {followUp.user.userprofile.usertype === 'LAB' && <span className='message-date'>Пользователь:</span>}
        {followUp.user.userprofile.usertype === 'LAWYER' && <span className='message-date'>Специалист АСНП:</span>}
        <span className='message-date'>{followUp.date}</span>
      </div>

    </>
  );
}


export default function TicketUpdate({selectedYear}){
  const[notFound, setNotFound] = useState(false);
  const[ticket, setTicket] = useState([]);
  const[updateNeeded, setUpdateNeeded] = useState(false);
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

  let { ticketId } = useParams();

  React.useEffect(() => {

    let apiReturnedTicket = axios_api.get(api_url + '/manage_ticket_legal/' + ticketId, {
      headers: {"Authorization": token}
    });

    apiReturnedTicket.then(
      (result) => {
        //console.log(result.data);
        setTicket(result.data);
      },
      (error) => {
        console.log(error)
        if (error.status === 404) {
          setNotFound(true)
        }
      }
    );

  }, []);

  //function UpdateChat() {
  //  setUpdateNeeded(!updateNeeded);
  //  alert(1)
  //}


  let rows = [];
  for (let i in ticket.follow_ups) {
    rows.push(
      <>
        <ChatMessage 
          key={i} 
          followUp={ticket.follow_ups[i]} 
        />
      </>
    ); 
  }

  return (
    <>
      {notFound === false ?
        <>  
          <div className="row">
            <h3 className="m-3">Обращение № {ticket.id}</h3>
            <h6 className="ms-3 mt-0">Лаборатория - {ticket.creator?.username}</h6>
          </div>

            
          <div className='row mt-2 m-3'>
            <div className='col-6 ps-0'>
              <div className='chat-fade'>
                <div className='px-5 py-4 vh-75 chat-background overflow-scroll'>
                  {rows}
                  <div className="d-grid d-md-flex justify-content-center">

                    <span className='mt-4 message-date'>-- начало переписки --</span>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-6 ps-5'>
              <TicketUpdateForm
                ticketId={ticket.id} 
              /> 
            </div>                     
          </div>
        </>
      :
        <div className="row">
          <h3 className="m-3">Обращение не найдено</h3>
        </div>
      }
    </>
  );
}